<template>
    <div>
        <el-tabs v-model="activeTabName" @tab-click="handleTabClick">
            <el-tab-pane label="商品列表" name="goodsList"></el-tab-pane>
        </el-tabs>
        <router-view class="router-view"></router-view>
    </div>
</template>

<script lang="ts">
import { createComponent, ref, Ref, reactive, onMounted } from "@vue/composition-api"
import { routerUtil } from '@/utils/routerUtil'

export default createComponent({
    setup(props, ctx) {
        const {
            activeTabName,
            handleTabClick
        } = routerUtil(ctx)

        onMounted(()=> {
            if([2140, 474, 2164].includes(Number(localStorage.getItem('shopId')))) return
            window.location.href = 'https://ls.senguo.cc/newadmin/#/main/goods/goodStorage/goodsLibrary'
        })

        return {
            activeTabName,
            handleTabClick
        }
    }
})
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__header {
    margin-bottom: 12px;
}

.router-view {
    height: calc(100vh - 145px);
}
</style>
